import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  addContactRole, changeContactRole, deleteContactRole, updateContact
} from 'bundles/apex/deals/show/store/deal/actions';

import AddControl from 'components/add_control/v2';
import ContactModal from 'bundles/backoffice/contacts/contact_modal';
import { ContactRolesCard } from 'bundles/backoffice/contacts/card';

import type { Category } from 'bundles/backoffice/contacts/groups';
import type { Deal } from 'bundles/apex/deals/types';

interface Props {
  category: Category;
}

export function DealContactRolesCard({ category }: Props) {
  const [showAddContactModal, setShowAddContactModal] = useState(false);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const deal: Deal = useSelector((state: any) => state.deal);
  const features: Record<string, boolean> = useSelector((state: any) => state.features);
  /* eslint-enable @typescript-eslint/no-explicit-any */

  const dispatch = useDispatch();

  const headerControls = <>
    <AddControl
      label={`Add ${category.contactLabel}`}
      onClick={() => setShowAddContactModal(true)}
    />

    <ContactModal
      addContactRole={contactRole => dispatch(addContactRole(contactRole))}
      allowTagging={features.crmTags}
      askForEmployer={features.contactsV2}
      availableContactRelationships={category.roles}
      confirmSharedAttributes={features.edgeCrm}
      contactLabel={category.contactLabel}
      multipleBusinesses={features.contactsV2}
      parentLabel="Deal"
      show={showAddContactModal}
      onClose={() => setShowAddContactModal(false)}
    />
  </>;

  return (
    <ContactRolesCard
      confirmDeletion
      contactLabel={category.contactLabel}
      contactRoles={category.contactRoles}
      features={features}
      forRecord={{ id: deal.voucherId, type: 'Backoffice::Voucher' }}
      header={category.header}
      headerControls={headerControls}
      required={category.required}
      onChangeContactRole={(contactRole, changes) => dispatch(changeContactRole(contactRole, changes))}
      onRemoveContactRole={contactRole => dispatch(deleteContactRole(contactRole))}
      onSaveContact={contact => dispatch(updateContact(contact))}
    />
  );
}
